module.exports = __webpack_public_path__ + "static/img/channel_search_item_05.1c6b3d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/worktype/channel_search_item_05.png
// module id = O0jJ
// module chunks = 0